import { createAction, props } from '@ngrx/store';

export const checkGeoLocation = createAction('[Geo] Check Location');

export const geoLocationSuccess = createAction(
  '[Geo] Location Success',
  props<{ isRegulated: boolean; country: string }>()
);

export const geoLocationFailure = createAction(
  '[Geo] Location Failure',
  props<{ error: any }>()
);

export const loadFromCache = createAction('[Geo] Load From Cache');